import CustomSelect from '@/views/custom_select';
import PopperTooltipV4 from '@/views/popper_tooltip_v4';

pageLoad('pages_test', () => {
  $('.b-input.test, .b-input-v4.test').each((_index, node) => new CustomSelect(node));
  $('.b-tooltip_trigger-v4').each((_index, node) => new PopperTooltipV4(node));
});
